'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isStateless = isStateless;
exports.makeDisplayName = makeDisplayName;

var _preact = require('preact');

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render) && !_preact.Component.isPrototypeOf(component);
}

function makeDisplayName(component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
        _ref$suffix = _ref.suffix,
        suffix = _ref$suffix === undefined ? '' : _ref$suffix;

    var displayName = component.displayName || component.name || component.constructor && component.constructor.name || '<component>';
    return prefix + displayName + suffix;
}


// WEBPACK FOOTER //
// ../node_modules/mobx-preact/lib/utils/utils.js